/** Public file store the requirements file is loaded from. */
export const PublicFilesUrl =
  "https://mobileupdate.infominds.eu/api/PublicFiles?requestedFileName=";
/** Name of the requirements file with the app information. */
export const RequirementsFileName = "requirements-mobile.json";
/** Base URL for the relative icon paths in the requirements file. */
export const RequirementsImagesUrl = "https://mobile.infominds.eu/requirements/";

export const AppRequirementsUrl = `${PublicFilesUrl}${RequirementsFileName}`;
